import React, { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';

function SidebarCampaign({ setStatus, statusCount, reload }) {
  const [campaigns, setCampaigns] = useState([]);
  const [statusActive, setStatusActive] = useState('all');

  useEffect(() => {
    const count = statusCount;
    const fetchedCampaigns = [
      { name: 'All', count: count.all ?? 0, status: 'all', colorStat: '#3498DB' },
      { name: 'Draft', count: count.draft ?? 0, status: 'draft', colorStat: '#b3b3b3' },
      { name: 'Scheduled', count: count.scheduled ?? 0, status: 'scheduled', colorStat: '#ffa047' },
      {
        name: 'In-Progress',
        count: count.in_progress ?? 0,
        status: 'in_progress',
        colorStat: '#1bf907',
      },
      { name: 'Completed', count: count.completed ?? 0, status: 'completed', colorStat: '#1faf38' },
      { name: 'Incomplete', count: count.incomplete ?? 0, status: 'incomplete', colorStat: '#f15a24' },
      { name: 'Failed', count: count.failed ?? 0, status: 'failed', colorStat: '#de0d19' },
    ];
    setCampaigns(fetchedCampaigns);
  }, [reload]);

  const handleItemClick = status => {
    if (setStatus) {
      setStatus(status);
    }
    setStatusActive(status);
  };

  return (
    <div className="SidebarCampaign">
      <div className="sidebar-title">
        <span className="toggle-name">STATUS</span>
      </div>
      <Nav as="ul" className="flex-column">
        {campaigns.map(campaign => (
          <Nav.Item as="li" key={campaign.status} onClick={() => handleItemClick(campaign.status)}>
            <Nav.Link className={statusActive === campaign.status ? 'active' : ''}>
              <span className="nav-name">
                <span className="nav-dot" style={{ background: campaign.colorStat }} />
                <span>{campaign.name}</span>
              </span>
              <span className="nav-item-count">{campaign.count}</span>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
}

export default SidebarCampaign;
